var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showMoveInOutComponent
    ? _c(
        "div",
        { staticClass: "move-in-out-component" },
        [
          _c(
            "Collapse",
            {
              attrs: {
                title: _vm.$t("handover.moveInOut.moveInOutTempReTransaction"),
                expand: true,
                withBorder: false,
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "content" }, slot: "content" },
                [
                  _vm.hasCreateUpdateAccess
                    ? _c("div", { staticClass: "move-in-out__toolbox" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "move-in-out__button-box float-left rows",
                          },
                          [
                            _c(
                              "HKLButton",
                              {
                                attrs: { color: "orange" },
                                on: { click: _vm.openMoveInModal },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("handover.moveInOut.addMoveIn")
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "HKLButton",
                              {
                                attrs: { color: "darkblue" },
                                on: { click: _vm.openMoveOutModal },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("handover.moveInOut.addMoveOut")
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "HKLButton",
                              {
                                attrs: { color: "orange" },
                                on: {
                                  click: function () {
                                    return _vm.openNewTempReopenModal(
                                      _vm.MOVE_TYPE.TEMP_ClOSE
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("handover.moveInOut.addTempClose")
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "HKLButton",
                              {
                                attrs: { color: "darkblue" },
                                on: {
                                  click: function () {
                                    return _vm.openNewTempReopenModal(
                                      _vm.MOVE_TYPE.REOPEN
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("handover.moveInOut.addReopen")
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "move-in-out__table" },
                    [
                      _c("CommonTable", {
                        attrs: {
                          tableContentLists: _vm.tableContents,
                          renderHeaderList: _vm.tableHeader,
                          interactionFunc: _vm.interactionFunc,
                          defaultOrder: false,
                          defaultOrderKey: "date",
                          orderMethods: _vm.orderMethods,
                          needFilter: false,
                          tableId: _vm.tableId,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("AddNewMoveInOutModal", {
                    ref: "editMoveModal",
                    on: { afterSave: _vm.loadData },
                  }),
                  _vm._v(" "),
                  _c("AddNewTempReopenModal", {
                    ref: "tempReopenModal",
                    on: { onAfterSave: _vm.loadData },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }